class IngredientsPopup extends HTMLElement {
  constructor() {
    super();
    this.breakpoint = window.matchMedia("(max-width: 991px)");
  }

  connectedCallback() {
    this.detailsElement = this.querySelector("details");
    this.summaryElement = this.detailsElement.firstElementChild;
    this.ingredientModal = this.querySelector(".ingredient-mobile");

    this.onDesktopMouseEnterBound = this.onDesktopMouseEnter.bind(this);
    this.onDesktopMouseLeaveBound = this.onDesktopMouseLeave.bind(this);
    this.onMobileClickBound = this.onMobileClick.bind(this);
    this.onOutsideClickBound = this.onOutsideClick.bind(this);

    this.onBreakPointChange(this.breakpoint);
    this.breakpoint.addEventListener("change", this.onBreakPointChange.bind(this));
  }

  onMobileClick(e) {
    e.preventDefault();
    // Toggle instead of only open
    if (this.detailsElement.hasAttribute("open")) {
      this.popupClose();
    } else {
      this.closeAllOtherPopups();
      this.popupOpen();
    }
  }

  onDesktopMouseEnter() {
    this.detailsElement.setAttribute("open", "");
  }

  onDesktopMouseLeave() {
    this.detailsElement.removeAttribute("open");
  }

  onBreakPointChange(e) {
    const isMobile = e.matches !== undefined ? e.matches : e;
    if (isMobile) {
      this.summaryElement.addEventListener("click", this.onMobileClickBound);
      this.removeEventListener("mouseenter", this.onDesktopMouseEnterBound);
      this.removeEventListener("mouseleave", this.onDesktopMouseLeaveBound);
      document.addEventListener("click", this.onOutsideClickBound);
    } else {
      this.summaryElement.removeEventListener("click", this.onMobileClickBound);
      this.addEventListener("mouseenter", this.onDesktopMouseEnterBound);
      this.addEventListener("mouseleave", this.onDesktopMouseLeaveBound);
      document.removeEventListener("click", this.onOutsideClickBound);
    }
  }

  closeAllOtherPopups() {
    document.querySelectorAll("ingredients-popup details[open]").forEach((el) => {
      if (el !== this.detailsElement) {
        el.removeAttribute("open");
        const mobile = el.closest("ingredients-popup")?.querySelector(".ingredient-mobile");
        if (mobile) mobile.style.display = "none";
      }
    });
  }

  onOutsideClick(e) {
    if (!this.contains(e.target) && this.detailsElement.hasAttribute("open")) {
      this.popupClose();
    }
  }

  popupOpen() {
    this.detailsElement.setAttribute("open", "");
    if (this.ingredientModal) {
      this.ingredientModal.style.display = "block";
    }
  }

  popupClose() {
    this.detailsElement.removeAttribute("open");
    if (this.ingredientModal) {
      this.ingredientModal.style.display = "none";
    }
  }
}

customElements.define("ingredients-popup", IngredientsPopup);